import { Container, Text } from "pixi.js";
import { MarketplaceNewsItem } from "../../models/news/MarketplaceNewsItem";
import { GameFont } from "../../../../../common/GameFont";
import { StringFormatExtention } from "../../../../../../../extensions/StringFormatExtention";

export class MarketplaceNewsItemView extends Container {
    private readonly newsText: Text;
    private readonly priceUsd: Text;

    public constructor() {
        super();
        this.newsText = new Text("", {
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40,
            fill: "#EBEBEB"
        });
        this.priceUsd = new Text("", {
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 40,
            fill: "#03D74B"
        });
        this.addChild(this.newsText, this.priceUsd);
    }

    public setData(data: MarketplaceNewsItem): void {
        this.newsText.text = `// ${data.type.toLowerCase()} ${data.address} ${data.zipCode} `;
        const price = data.price.mon != null ? `${StringFormatExtention.tokensFormat(data.price.mon.toString())} MON ` : `$${StringFormatExtention.formatWithComma(data.price.usd)} `;
        this.priceUsd.text = price;
        this.priceUsd.position.x = this.newsText.width;
    }

    public clear(): void {
        this.newsText.text = "";
        this.priceUsd.text = "";
    }
}
